import { render, staticRenderFns } from "./DaletFileManager.vue?vue&type=template&id=871a0d44&"
import script from "./DaletFileManager.vue?vue&type=script&lang=js&"
export * from "./DaletFileManager.vue?vue&type=script&lang=js&"
import style0 from "./DaletFileManager.vue?vue&type=style&index=0&id=871a0d44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports